import React from 'react';
import { bool } from 'prop-types';
import { CardTitle, Typography, Link } from '@one-thd/sui-atomic-components';
import { Orders } from '@one-thd/sui-icons';
import { showAboveSmBreakpointIf } from '../../constants/responsiveClassNames';

const QuotesHeader = ({ hasQuotes }) => {
  return (
    <CardTitle
      header={(
        <div className="sui-flex sui-gap-3 sui-items-center">
          <Orders /><Typography variant="h4" weight="display">Quotes</Typography>
        </div>
      )}
      actionPosition="end"
      action={(
        <div className={showAboveSmBreakpointIf(hasQuotes)}>
          <Link href="/quote/list">View All Quotes</Link>
        </div>
      )}
    />
  );
};

QuotesHeader.propTypes = {
  hasQuotes: bool.isRequired,
};

export default QuotesHeader;